export const budgetRevenuesData = [
  {
    RevenueName: "Training Programs",
    CategoryName: "Training",
    SubCategoryName: "Employee Training",
    Amount: "20000",
    ExpenseDate: "14/01/2024",
    key: "1",
  },
  {
    RevenueName: "Premium Support Packages",
    CategoryName: "Support & Maintenance",
    SubCategoryName: "Premium Support",
    Amount: "40000",
    ExpenseDate: "21/01/2024",
    key: "1",
  },
  {
    RevenueName: "Consulting Services",
    CategoryName: "Services",
    SubCategoryName: "Consulting",
    Amount: "10000",
    ExpenseDate: "10/02/2024",
    key: "1",
  },
  {
    RevenueName: "Subscription Fees",
    CategoryName: "Platform Fees",
    SubCategoryName: "Subscription Plans",
    Amount: "20000",
    ExpenseDate: "18/02/2024",
    key: "1",
  },
];
